import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StyledAuthButton } from 'pages/NIC/styled';
import { authenticateClickHandler } from 'pages/NIC/utils/helpers';
export var NICAuthBtn = function () { return (_jsx(StyledAuthButton, { onClick: function () { return authenticateClickHandler(); }, children: "Click to authenticate" })); };
